export class StanderedItem {
    id: number
    name: string
}

export class StanderedResponseModel {
    count: number
    next: string
    previous: string
    results: StanderedItem[]

}